/**
 * Created by Andrey Popov on 02.03.2026.
 */

const UnitsSyncers = function () {
    this.instances = {};

    Meta.SLOTS.forEach((slotId) => this.getInstance(slotId));
};

UnitsSyncers.prototype.getInstance = function (slotId) {
    if (!this.instances[slotId]) {
        this.instances[slotId] = new UnitsSyncer(slotId);
    }
    return this.instances[slotId];
};

UnitsSyncers.prototype.reset = function () {
    Object.values(this.instances).forEach((instance) => {
        instance.reset();
    });
};

UniversalSlot.HANDLER_FACTORIES.unitsSyncers = (slot) => ({
    reset: () => cleverapps.unitsSyncers.getInstance(slot.slotId).reset()
});
